export default __webpack_public_path__ + "static/media/Snd_D_Starts.8dd738ae.mp3";